
document.addEventListener("DOMContentLoaded", () => {

  /* --- CONFIG ------------------------------------------------------------ */
  const MINUS_SELECTOR = ".quantity-selector__button";   // aggiungi altri selettori separati da virgola se servono
  const TOAST_FLAG     = "show_remove_toast_after_reload";
  const headersJSON    = { "Content-Type":"application/json" };

  /* --- MOSTRA TOAST DOPO RELOAD ------------------------------------------ */
  if (sessionStorage.getItem(TOAST_FLAG) === "true") {
    sessionStorage.removeItem(TOAST_FLAG);
    showUndoToast();
  }

  /* --- 1. CLICK SUL PULSANTE “RIMUOVI” ----------------------------------- */
  document.querySelectorAll(".remove-btn").forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      handleRemoval({
        lineKey   : btn.dataset.lineKey,
        variantId : btn.dataset.variantId,
        quantity  : parseInt(btn.dataset.quantity, 10)
      }, /*manualFetch*/ true);                   // rimuoviamo noi via fetch
    });
  });

  /* --- 2. CLICK SU “–” CHE IMPOSTA quantity=0 ---------------------------- */
  // Creiamo la MAPPA lineIndex → { variantId, quantity } all’avvio
  let lineMap = {};
  fetch("/cart.js")
    .then(r => r.json())
    .then(cart => {
      cart.items.forEach((item, idx) => {
        lineMap[idx + 1] = { variantId: item.variant_id, quantity: item.quantity };
      });
    })
    .then(() => {
      // Dopo aver popolato la mappa, agganciamo gli handler ai link “–”
      document.querySelectorAll(MINUS_SELECTOR).forEach(a => {
        a.addEventListener("click", () => {
          const url = new URL(a.getAttribute("href"), location.origin);
          if (url.pathname !== "/cart/change") return;           // sicurezza
          if (url.searchParams.get("quantity") !== "0") return;  // non è una rimozione

          const lineIndex = parseInt(url.searchParams.get("line"), 10);
          const info      = lineMap[lineIndex];
          if (!info) return;  // paranoia

          // Salviamo i dati per l'Undo (e NON blocchiamo la navigazione)
          prepareUndo(info.variantId, info.quantity);
          // Nessun preventDefault: Shopify gestisce la rimozione via link
          sessionStorage.setItem(TOAST_FLAG, "true");
        });
      });
    });

  /* --- FUNZIONI COMUNI --------------------------------------------------- */
  function prepareUndo(variantId, quantity) {
    sessionStorage.setItem("last_removed_variant_id", variantId);
    sessionStorage.setItem("last_removed_quantity",   quantity);
  }

  function handleRemoval({ lineKey, variantId, quantity }, manualFetch = false) {
    if (!variantId) return;
    prepareUndo(variantId, quantity);
    sessionStorage.setItem(TOAST_FLAG, "true");

    if (manualFetch) {
      fetch("/cart/change.js", {
        method : "POST",
        headers: headersJSON,
        body   : JSON.stringify({ id: lineKey, quantity: 0 })
      }).then(() => location.reload());
    }
    // altrimenti (minus‐link) lasciamo la navigazione naturale
  }

  function showUndoToast() {
    const toast = document.getElementById("remove-toast");
    if (toast) {
      toast.style.display = "flex";
      setTimeout(() => (toast.style.display = "none"), 5000);
    }
  }

  document.getElementById("undo-remove")?.addEventListener("click", () => {
    const variantId = sessionStorage.getItem("last_removed_variant_id");
    const quantity  = parseInt(sessionStorage.getItem("last_removed_quantity"), 10);
    if (!variantId || !quantity) return;

    fetch("/cart/add.js", {
      method : "POST",
      headers: headersJSON,
      body   : JSON.stringify({ id: variantId, quantity })
    }).then(() => {
      sessionStorage.clear();
      location.reload();
    });
  });
});